import { render } from "./legoGrid.vue?vue&type=template&id=4fea429e"
import script from "./legoGrid.vue?vue&type=script&lang=js"
export * from "./legoGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/layout/legoGrid/legoGrid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4fea429e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4fea429e', __exports__)) {
    api.reload('4fea429e', __exports__)
  }
  
  module.hot.accept("./legoGrid.vue?vue&type=template&id=4fea429e", () => {
    api.rerender('4fea429e', render)
  })

}


export default __exports__